module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/add/add.component.html
// module id = 1545
// module chunks = 2